class StrokeAnalysisCtrl
  constructor: (@$scope) ->
    @strokeData =
      avg_shot_par3: 0
      avg_shot_par4: 0
      avg_shot_par5: 0

    @$scope.$on "myAnalysisUpdated.gnp.analysis", (event, myAnalysis) =>
      @strokeData = myAnalysis.my_avg

StrokeAnalysisCtrl.$inject = [
  '$scope'
]
module.exports = StrokeAnalysisCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/stroke-analysis/stroke-analysis-controller.coffee